import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import {faEllipsisV, faGlobeEurope, faPen, faUser} from '@fortawesome/free-solid-svg-icons';
import {faEllipsisH} from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import {TranslateService} from '../shared/services/translate.service';
import {LoginService} from '../login-page/services/login.service';
import {Router} from '@angular/router';
import {MenuService} from '../shared/services/menuService/menu.service';
import {EditService} from '../shared/services/editService/edit.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {

  faUser = faUser;
  faEdit = faPen;
  language = faGlobeEurope;
  menuClose = faEllipsisV;
  menuOpen = faEllipsisH;
  pathToFlag: string;
  login: string;
  buttons = [
    {
      tag: 'cz',
      name: 'common.toolbar.languageMenu.cz',
      img: '../../assets/img/cz.png'
    }
  ];


  constructor(private translate: TranslateService,
              private loginService: LoginService,
              private router: Router,
              private menuService: MenuService,
              private editService: EditService) {
    this.login = loginService.getLogin();
    if ( _.isUndefined(this.login)) {
      this.logout();
      return;
    }
    switch (translate.usedLang) {
      case 'cz':
        this.pathToFlag = './../../assets/img/cz.png';
        break;
      default:
        console.error('language not found');
    }
    this.setLanguage(translate.usedLang);
  }

  ngOnInit() {
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    switch (lang) {
      case 'cz':
        this.pathToFlag = './../../assets/img/cz.png';
        break;
      default:
        console.error('language not found');
    }
  }

  isOpen():boolean {
    return this.menuService.toggle;
  }

  getCurrentLang() {
    return this.translate.usedLang;
  }

  toggleMenu() {
    this.menuService.toggleMenu();
  }

  logout() {
    this.loginService.destroyToken();
    this.router.navigate(['/login']);
  }

  edit() {
    this.editService.toogle();
  }

  getEditState() {
    return this.editService.editable;
  }

}
